import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import { ConflictError } from './postEntities'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import EntityToCreate = com.eidu.sharedlib.entity.api.entities.EntityToCreate
import EntityId = com.eidu.sharedlib.entity.EntityId
import entityIdFromString = com.eidu.sharedlib.entity.entityIdFromString

type PostEntityParameters = {
  entity: EntityToCreate
}

const postEntity = async ({ entity }: PostEntityParameters): Promise<EntityId> => {
  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/entities/new`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(entity),
      method: 'POST',
    }
  )
  if (response.status === 409) {
    throw new ConflictError('Entity already exists')
  } else if (response.status !== 201) {
    throw Error(`Unexpected response code ${response.status} from postEntity endpoint`)
  }

  const newId = await response.json()
  return entityIdFromString(newId)
}

export default postEntity
